export enum ActionArea {
  Header = 'header',
  Content = 'content',
  Footer = 'footer',
  Layer = 'layer',
}
